import moment from 'moment';
import 'moment-precise-range-plugin';

export const formatDate = (date, format = 'DD/MM/YYYY, h:mmA') => {
    return moment(date)
        .format(format);
};

export const differenceBetweenTime = (date, output = 'string') => {
    const _date = moment(date);
    const now = moment();

    const diff = moment.preciseDiff(_date, now, true);

    const getTimeUnit = (value, unit) => `${value}${unit}${value !== 1 ? `s` : ''}`;

    const {years, months, days, hours, minutes, seconds} = diff;

    const yrUnit = getTimeUnit(years, 'yr');
    const mthUnit = getTimeUnit(months, 'mth');
    const dayUnit = getTimeUnit(days, 'day');
    const hrUnit = getTimeUnit(hours, 'hr');
    const minUnit = getTimeUnit(minutes, 'min');
    const secUnit = getTimeUnit(seconds, 'sec');

    if (output === 'string') {
        let result = '';

        if (years) result += `${yrUnit} : `;
        if (months) result += `${mthUnit} : `;
        if (days) result += `${dayUnit} : `;
        result += `${hrUnit} : `;
        result += `${minUnit} : `;
        result += `${secUnit}`;

        return result;
    } else if (output === 'object') {
        return {
            days,
            hours,
            minutes,
            seconds
        };
    }
};

export const padding = (n, width, z = '0') => {
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};

export const formatPhoneNumber = phoneNumberString => {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) return `${match[1]}-${match[2]}-${match[3]}`;
    return null;
};
